<template>
  <div class="wishlist-page row">
    <div v-if="loaded && !items.length" class="col-sm-12 text-center">
      <div class="big-message">I'm Empty !!!</div>
      <p class="help-block">To add an item, click "add to wishlist" while shopping.</p>
    </div>
    <div v-if="loaded && items.length" class="col-sm-12">
      <div class="row">
        <div v-if="preview === 0" class="col-sm-12 wishlist-title">
          <h4 class="text-primary pull-left wishlist-title">Manage your list</h4>
          <modal-btn class="pull-right" modal="shareWishlist" :captcha="true">
            <span slot-scope="slotProps">
              <a @click="slotProps.showModal">
                <i class="glyphicon glyphicon-envelope"></i> E-mail wishlist
              </a>
              to your friends
              </span>
          </modal-btn>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm-12 wishlist-items">
          <div class="row">
            <div
              v-for="(result, index) in items"
              :index="index"
              :key="result.accountwishlistID"
              class="col-sm-12 col-md-6">
              <wishlist-item
                :item="result"
                :preview="preview"
                v-on:removeItem="removeFromList"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <share-wishlist-modal v-if="preview === 0"  :recaptcha-key="recaptchaKey"/>
  </div>
</template>

<style scoped>
.wishlist-page h4 {
  margin: 0;
}
</style>

<script>
import axios from 'axios'
import { jrNotifyEx } from '../../bootstrap'
import WishlistItem from './WishlistItem'
import ModalBtn from '../ModalBtn'
import ShareWishlistModal from './ShareWishistModal'

export default {
    components: {
        'wishlist-item': WishlistItem,
        'modal-btn': ModalBtn,
        'share-wishlist-modal': ShareWishlistModal,
    },

    props: {
        initialItems: {
            type: Object,
            default: null,
        },
        preview: {
            type: Number,
            default: 1
        },
        recaptchaKey: {
            type: String,
            default: null
        }
    },

    data () {
        return {
            loaded: false,
            items: []
        }
    },

    async created () {
        if (this.initialItems && this.initialItems.data) {
            this.items = this.initialItems.data
            this.loaded = true
        } else {
            try {
                const response = await axios.get('/wishlist')
                this.items = response.data.data
                this.loaded = true
            } catch (e) {
                jrNotifyEx(e)
            }
        }
    },

    methods: {
        async removeFromList (id) {
            try {
                const response = await axios.post('/wishlist/remove-item', {id: id})
                this.items = response.data.data
            } catch (e) {
                jrNotifyEx(e)
            }
        }
    }
}
</script>
